import React from 'react';
import CreatePasswordForm from '../../components/CreatePassword/CreatePasswordForm';
import routeConstant from '../../lib/constants/routeConstant';
import AuthenticationLayout from '../../components/AuthenticationLayout/AuthenticationLayout';


/*  Options object to determine the visibility and properties of the navigation button in the authentication layout. */
const options = {
  showButton: true,
  navUrl: routeConstant.LOGIN_PAGE,
  buttonName: "Login",
  heading: "Create Password",
  subHeading: "Create Your Password Here"
}

const CreatePasswordPage = () => {
  return (
     /* Render the AuthenticationLayout component as a wrapper around the CreatePasswordForm. Pass the options object 
     to control the layout's property */
    <AuthenticationLayout options={options}>
      <CreatePasswordForm />
    </AuthenticationLayout>
  )
}

export default CreatePasswordPage